<template>
  <section class="co-bg-striped te-famale-bg">
    <div class="co-container-lg mx-auto px-4 py-10 md:py-20">
      <!-- タイトル -->
      <h2 class="co-heading-2">
        <div class="flex flex-col items-center justify-center md:flex-row md:items-end">
          <picture class="mr-0 md:mr-3 md:mt-9">
            <source
              srcset="~/assets/images/Te/TeCounseling/Famale/trial-woman-title-object-pc.svg"
              media="(min-width: 768px)"
            >
            <img
              src="~/assets/images/Te/TeCounseling/Famale/trial-woman-title-object-sp.svg"
              alt="女性も安心"
              class="mx-auto"
              loading="lazy"
            >
          </picture>女性の受講生が増えています
        </div>
      </h2>

      <!-- 受講生 -->
      <div class="te-famale-user-wrap flex flex-col justify-center md:flex-row">
        <!-- 1人目 -->
        <div class="mx-4 flex flex-row items-center justify-center md:mx-0 md:flex-col md:justify-start">
          <picture class="mr-0 md:mr-3">
            <source
              srcset="~/assets/images/Te/TeCounseling/Famale/female-user-hatanaka-pc.png"
              media="(min-width: 768px)"
              width="384"
            >
            <img
              src="~/assets/images/Te/TeCounseling/Famale/female-user-hatanaka-sp.png"
              alt="畑中祐紀さん"
              width="138"
              class="mx-auto"
              loading="lazy"
            >
          </picture>
          <div class="te-famele-user-text pl-3 md:pl-0">
            <span class="co-marker-yellow-1 font-bold">在宅ワーク</span>で<span class="co-marker-yellow-1 font-bold">育児</span>と<span class="co-marker-yellow-1 font-bold">仕事</span>と
            <br>
            <span class="co-marker-yellow-1 font-bold">両立</span>できるようになりました
          </div>
        </div>
        <!-- 2人目 -->
        <div class="mx-4 flex flex-row-reverse items-center justify-center md:mx-0 md:mt-[3.25rem] md:flex-col md:justify-start">
          <picture class="mr-0 md:mr-3">
            <source
              srcset="~/assets/images/Te/TeCounseling/Famale/female-user-kakiuchi-pc.png"
              media="(min-width: 768px)"
              width="384"
            >
            <img
              src="~/assets/images/Te/TeCounseling/Famale/female-user-kakiuchi-sp.png"
              alt="垣内晴賀さん"
              width="138"
              class="mx-auto"
              loading="lazy"
            >
          </picture>
          <div class="te-famele-user-text pl-3 md:pl-0">
            <span class="co-marker-yellow-1 font-bold">転職</span>して子供に<span class="co-marker-yellow-1 font-bold">おかえり</span>が
            <br>
            言えるようになりました
          </div>
        </div>
        <!-- 3人目 -->
        <div class="mx-4 flex flex-row items-center justify-center md:mx-0 md:mt-5 md:flex-col md:justify-start">
          <picture class="mr-0 md:mr-3">
            <source
              srcset="~/assets/images/Te/TeCounseling/Famale/female-user-iwagami-pc.png"
              media="(min-width: 768px)"
              width="384"
            >
            <img
              src="~/assets/images/Te/TeCounseling/Famale/female-user-iwagami-sp.png"
              alt="岩神美紀さん"
              width="138"
              class="mx-auto"
              loading="lazy"
            >
          </picture>
          <div class="te-famele-user-text pl-3 md:pl-0">
            <span class="co-marker-yellow-1 font-bold">40代</span>から受講して<span class="co-marker-yellow-1 font-bold">農業</span>から
            <br>
            <span class="co-marker-yellow-1 font-bold">Webデザイナー</span>へ挑戦！
          </div>
        </div>
      </div>

      <!-- 相談した方の声 -->
      <div class="relative lg:mt-[3.75rem]">
        <h3 class="pt-10 text-center md:pt-9">
          <picture>
            <source
              srcset="~/assets/images/Te/TeCounseling/Famale/famale-voice-title-pc.svg"
              media="(min-width: 992px)"
              width="210"
              height="226"
            >
            <img
              src="~/assets/images/Te/TeCounseling/Famale/famale-voice-title-sp.svg"
              alt="実際にやってみて感じた 相談した方の声"
              width="246"
              height="124"
              class="mx-auto"
              loading="lazy"
            >
          </picture>
        </h3>

        <!-- SP表示 -->
        <div class="mx-7 sm:mx-20 lg:hidden">
          <Swiper
            :modules="[SwiperPagination]"
            :slides-per-view="1"
            :breakpoints="{
              '576': {
                slidesPerView: 2,
              },
            }"
            :pagination="{
              clickable: true,
            }"
            class="!px-px"
          >
            <SwiperSlide
              :key="1"
              class="!h-auto"
            >
              <img
                class="mx-auto w-full"
                src="~/assets/images/Te/TeCounseling/Famale/famale-comment-sp-1.svg"
                loading="lazy"
                alt="親身になって答えていただけましたメンターさんのライフスタイルに憧れて決めました"
              >
            </SwiperSlide>
            <SwiperSlide
              :key="2"
              class="!h-auto"
            >
              <img
                class="mx-auto w-full"
                src="~/assets/images/Te/TeCounseling/Famale/famale-comment-sp-2.svg"
                loading="lazy"
                alt="全くの初心者の私でも受け入れてくれて嬉しかった営業されなくて安心しました"
              >
            </SwiperSlide>
            <SwiperSlide
              :key="3"
              class="!h-auto"
            >
              <img
                class="mx-auto w-full"
                src="~/assets/images/Te/TeCounseling/Famale/famale-comment-sp-3.svg"
                loading="lazy"
                alt="やりきれるか不安だったが、無料相談に来ている時点で素質のある人だから大丈夫と言われて決めました"
              >
            </SwiperSlide>
            <SwiperSlide
              :key="4"
              class="!h-auto"
            >
              <img
                class="mx-auto w-full"
                src="~/assets/images/Te/TeCounseling/Famale/famale-comment-sp-4.svg"
                loading="lazy"
                alt="今までどんな学習も独学で続けられなかったのですが具体的な学習方法が聞けて安心しました"
              >
            </SwiperSlide>
          </Swiper>
        </div>

        <!-- PC表示 -->
        <div class="te-famale-comment-pc absolute gap-[14.5625rem]">
          <div>
            <img
              class="mx-auto w-full"
              src="~/assets/images/Te/TeCounseling/Famale/famale-comment-pc-1.svg"
              loading="lazy"
              alt="親身になって答えていただけましたメンターさんのライフスタイルに憧れて決めました"
            >
          </div>
          <div class="mt-5">
            <img
              class="mx-auto w-full"
              src="~/assets/images/Te/TeCounseling/Famale/famale-comment-pc-2.svg"
              loading="lazy"
              alt="全くの初心者の私でも受け入れてくれて嬉しかった営業されなくて安心しました"
            >
          </div>
        </div>
        <div class="te-famale-comment-pc te-famale-comment-pc-bottom absolute gap-60">
          <div>
            <img
              class="w-full"
              src="~/assets/images/Te/TeCounseling/Famale/famale-comment-pc-3.svg"
              loading="lazy"
              alt="やりきれるか不安だったが、無料相談に来ている時点で素質のある人だから大丈夫と言われて決めました"
            >
          </div>
          <div class="mt-3">
            <img
              class="w-full"
              src="~/assets/images/Te/TeCounseling/Famale/famale-comment-pc-4.svg"
              loading="lazy"
              alt="今までどんな学習も独学で続けられなかったのですが具体的な学習方法が聞けて安心しました"
            >
          </div>
        </div>
      </div>

      <!-- スキル習得する方が増えてます -->
      <div class="mt-[4.25rem] text-center md:mt-[6.75rem]">
        <picture>
          <source
            srcset="~/assets/images/Te/TeCounseling/Famale/famale-graf-pc.svg"
            media="(min-width: 768px)"
            width="499"
            height="182"
          >
          <img
            src="~/assets/images/Te/TeCounseling/Famale/famale-graf-sp.svg"
            alt="スキル習得する方が増えてます 受講生の約半分以上は女性"
            width="251"
            height="271"
            class="mx-auto"
            loading="lazy"
          >
        </picture>
      </div>

      <!-- 受講に関するお悩みや将来について私達にお話聞かせてください -->
      <div class="mt-10 text-center md:mt-[3.75rem]">
        <picture>
          <source
            srcset="~/assets/images/Te/TeCounseling/Famale/famale-counselor-pc.png"
            media="(min-width: 768px)"
            width="580"
            height="147"
          >
          <img
            src="~/assets/images/Te/TeCounseling/Famale/famale-counselor-sp.png"
            alt="受講に関するお悩みや将来について私達にお話聞かせてください"
            width="319"
            height="197"
            class="mx-auto"
            loading="lazy"
          >
        </picture>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');

/* 背景 */
.te-famale-bg {
  @media (min-width: 768px) {
    background-image: url('~/assets/images/Te/TeCounseling/Famale/famale-bg-pc.png');
    background-repeat: no-repeat;
    background-position: center 5rem;
    background-size: contain;
  }
  @media (min-width: 992px) {
    background-position: center top;
  }
  @media (min-width: 1920px) {
    background-position: center -10rem;
    background-size: cover;
  }
}

/* 受講生 */
.te-famale-user-wrap {
  background-image: url('~/assets/images/Te/TeCounseling/Famale/famale-bg-sp-top.png'),
    url('~/assets/images/Te/TeCounseling/Famale/famale-bg-sp-bottom.png');
  background-repeat: no-repeat;
  background-position: center top, center bottom;
  background-size: cover, cover;
  @media (min-width: 768px) {
    gap: 2.5rem;
    background-image: none;
  }
}

.te-famele-user-text {
  position: relative;
  font-size: 0.875rem;
  @media (min-width: 768px) {
    margin-top: -0.5rem;
    font-size: 1rem;
  }
  @media (min-width: 992px) {
    margin-top: -1rem;
  }
  @media (min-width: 1200px) {
    margin-top: -1.75rem;
    font-size: 1.25rem;
  }
}

.te-famele-user-text::before {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 0.625rem;
  height: 1.25rem;
  content: '';
  border-top: 2px solid #ddd;
  border-left: 2px solid #ddd;
  @media (min-width: 768px) {
    left: -0.7rem;
    border-top: 4px solid #ddd;
    border-left: 4px solid #ddd;
  }
  @media (min-width: 992px) {
    left: -1.25rem;
    border-top: 4px solid #ddd;
    border-left: 4px solid #ddd;
  }
}

.te-famele-user-text::after {
  position: absolute;
  right: -0.625rem;
  bottom: 0;
  display: block;
  width: 0.625rem;
  height: 1.25rem;
  content: '';
  border-right: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
  @media (min-width: 768px) {
    border-right: 4px solid #ddd;
    border-bottom: 4px solid #ddd;
  }
}

/* マーカー */
.co-marker-yellow-1 {
  background: linear-gradient(transparent 70%, #ff3 0%);
}

.te-famale-comment-pc {
  top: 0;
  display: none;
  @media (min-width: 992px) {
    display: flex;
  }
}

.te-famale-comment-pc-bottom {
  @media (min-width: 992px) {
    top: 11rem;
  }
}

</style>
